

export const FAQ_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    question: "What is the duration of the course?",
    answer: "The course duration is typically 1 year.",
    priority: 1,
  },

  FAQ_FIELDS_CONFIG: [
    {
      fieldName: "title",
      label: "FAQ Section Title",
      value: "Frequently Asked Questions",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter FAQ Section Title",
      required: false,
      defaultValue: "Frequently Asked Questions",
    },
    {
      fieldName: "title_text_color",
      label: "Title Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter title text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "section_background_color",
      label: "Section background (full width)",
      value: "#F5F5F5",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Full-bleed band behind FAQ (e.g. #F5F5F5)",
      required: false,
      defaultValue: "#F5F5F5",
    },
    {
      fieldName: "status",
      label: "FAQ Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable FAQ Section",
      required: false,
      defaultValue: false,
    },
  ],

  // Category fields configuration for Form_3
  CATEGORY_FIELDS_CONFIG: [
    {
      fieldName: "name",
      label: "Category Name",
      value: "",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter category name (e.g., Courses, Fee, Curriculum)",
      required: true,
      defaultValue: "",
    },
    {
      fieldName: "text_color",
      label: "Category Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category text color (e.g., #000000)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "background_color",
      label: "Category Background Color",
      value: "#ffffff",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter category background color (e.g., #ffffff)",
      required: false,
      defaultValue: "#ffffff",
    },
    {
      fieldName: "order_index",
      label: "Display Order",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter display order (1, 2, 3...)",
      required: true,
      defaultValue: 1,
    },
    {
      fieldName: "status",
      label: "Category Status",
      value: true,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable category",
      defaultValue: true,
    },
  ],

  // FAQ table fields configuration for Form_3
  FAQ_TABLE_FIELDS_CONFIG: [
    {
      header: "Question",
      fieldName: "question",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter question",
      required: true,
    },
    {
      header: "Question Text Color",
      fieldName: "question_text_color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter question text color (e.g., #000000)",
      required: false,
    },
    {
      header: "Answer",
      fieldName: "answer",
      value: "",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter answer",
      required: true,
    },
    {
      header: "Answer Text Color",
      fieldName: "answer_text_color",
      value: "#666666",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter answer text color (e.g., #666666)",
      required: false,
    },
    {
      header: "Priority",
      fieldName: "priority",
      value: 1,
      valueType: "number",
      filedType: "INPUT",
      placeholder: "Enter priority (1, 2, 3...)",
      required: true,
    },
  ],
};
